/** @format */

import React from 'react';
import { Grid } from '@mui/material';
import { NewGuildItem, NewGuildItemCartable } from './components';
import { useCurrencyUnit } from 'hooks';

const Guild = (props) => {
  const {
    dataGuild,
    accDetails,
    isDisableAll,
    setIsDisableAll,
    refreshList = () => { },
  } = props;

  const currencyText = useCurrencyUnit()
  const getBlockAccount = () => {
    return null;
  };

  return (
    <>
      <Grid container spacing={2}>
        {dataGuild.map((item, k) =>
          item?.cartable ? (
            <Grid item xs={12} md={6} lg={4}>
              <NewGuildItemCartable
                data={item}
                dataGuild={dataGuild}
                accDetails={accDetails}
                key={k}
                itemKey={k}
                refreshList={refreshList}
                blockedAccount={getBlockAccount(item?.guildSrv?.code)}
                setIsDisableAll={setIsDisableAll}
                isDisableAll={isDisableAll}
                currencyText={currencyText}
              />
            </Grid>
          ) : (
            <Grid item xs={12} md={6} lg={4}>
              <NewGuildItem
                data={item}
                dataGuild={dataGuild}
                accDetails={accDetails}
                key={k}
                itemKey={k}
                refreshList={refreshList}
                blockedAccount={getBlockAccount(item?.guildSrv?.code)}
                setIsDisableAll={setIsDisableAll}
                isDisableAll={isDisableAll}
                currencyText={currencyText}
              />
            </Grid>
          ),
        )}
      </Grid>
    </>
  );
};
export default Guild;
